module.exports = __webpack_public_path__ + "assets/fonts/glyphicons-halflings-regular.ttf";


/*****************
 ** WEBPACK FOOTER
 ** ./~/bootstrap/dist/fonts/glyphicons-halflings-regular.ttf
 ** module id = 1087
 ** module chunks = 0
 **/